module.exports = __webpack_public_path__ + "img/conhome-logo-new-final.298e7ac8.svg";